export default __webpack_public_path__ + "static/media/NodeJS.bcd38974.png";